import { render, staticRenderFns } from "./HardcodedNumber.vue?vue&type=template&id=2edff306&scoped=true&lang=html"
import script from "./HardcodedNumber.vue?vue&type=script&lang=js"
export * from "./HardcodedNumber.vue?vue&type=script&lang=js"
import style0 from "./HardcodedNumber.vue?vue&type=style&index=0&id=2edff306&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edff306",
  null
  
)

export default component.exports